// components/Text.tsx
import { cva, type VariantProps } from 'class-variance-authority';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { PolymorphicProps } from '@/lib/types/helpers';

export const textStyles = cva('font-sans', {
  variants: {
    variant: {
      inherit: 'font-inherit leading-inherit text-inherit',
      'title-xs': 'title-xs',
      'title-md': 'title-md',
      'title-sm': 'title-sm',
      'title-xxs': 'title-xxs',
      'body-xxs': 'body-xxs',
      'body-xs': 'body-xs',
      'title-large': 'title-md md:title-lg',
      'body-large-1': 'body-large-1',
      'body-large-2': 'body-large-2',
      'body-small': 'body-small',
      'body-medium': 'md:body-medium body-small',
      'label-md': 'label-md',
      'label-lg': 'label-lg',
    },
  },
  defaultVariants: { variant: 'inherit' },
});

export type TextProps<C extends React.ElementType = 'span'> = PolymorphicProps<
  C,
  VariantProps<typeof textStyles> & { className?: string }
> &
  PropsWithChildren;

export function Text<C extends React.ElementType = 'span'>({
  as,
  variant,
  className,
  ...props
}: TextProps<C>) {
  const Component = as || 'span';
  const base = textStyles({ variant });
  const merged = twMerge(clsx(base, className));
  return <Component className={merged} {...props} />;
}
